export default {
  coupons: (state) => state.coupons
}
